// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M7.95 11.98L5.13 10.73C4.7 10.47 4.42 10.12 4.28 9.65L2.3 3.15C2.19 2.61 2.61 2.19 3.15 2.3L9.65 4.28C10.12 4.42 10.47 4.7 10.73 5.13L11.98 7.95',
  'M7.95 11.98L11.98 7.95C12.24 7.7 12.65 7.7 12.9 7.95L13.5 8.55C13.76 8.81 13.76 9.22 13.5 9.47L9.47 13.5C9.22 13.76 8.81 13.76 8.55 13.5L7.95 12.9C7.7 12.65 7.7 12.24 7.95 11.98Z',
  'M2.48 2.48L5.94 5.94',
  'M7.71 5.94C8.19 6.43 8.19 7.22 7.71 7.71C7.22 8.19 6.43 8.19 5.94 7.71C5.45 7.22 5.45 6.43 5.94 5.94C6.43 5.45 7.22 5.45 7.71 5.94Z',
];
